import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { motion } from 'framer-motion';

/** Branded full-screen splash shown while the app checks who is signed in. */
export function SplashScreen({ message = 'Getting things ready…' }) {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        height: '100dvh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        gap: 2.5, bgcolor: 'var(--app-background)',
      }}
    >
      <motion.div initial={{ opacity: 0, scale: 0.92 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.4 }}>
        <Typography sx={{
          fontFamily: 'var(--font-display)', fontSize: '2.6rem', lineHeight: 1,
          background: 'linear-gradient(130deg, var(--app-primary) 0%, var(--app-secondary) 100%)',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
        }}>
          Celebrations
        </Typography>
      </motion.div>
      <CircularProgress size={30} sx={{ color: 'var(--app-primary)' }} />
      <Typography sx={{ color: 'var(--app-text-muted)', fontSize: '0.8rem', fontWeight: 600 }}>{message}</Typography>
    </Box>
  );
}
